import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useLocation } from "wouter";
import { LoadingPanel } from "./LoadingPanel";

export function LogoutReturnView() {
  const { removeUser } = useAuth();
  const [, setLocation] = useLocation();

  useEffect(() => {
    let cancelled = false;
    void removeUser().finally(() => {
      if (!cancelled) setLocation("/", { replace: true });
    });
    return () => {
      cancelled = true;
    };
  }, [removeUser, setLocation]);

  return <LoadingPanel message="Completing sign out" />;
}
